import { useState, useEffect, useCallback } from 'react';

interface UseBTCoinListReturn {
  coins: string[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useBTCoinList = (): UseBTCoinListReturn => {
  const [coins, setCoins] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCoins = useCallback(async (): Promise<void> => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch('/mercury-backend/bt/coin-list');
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      
      if (result.success && Array.isArray(result.data)) {
        setCoins(result.data);
      } else {
        setCoins([]);
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Unknown error occurred';
      setError(errorMessage);
      console.error('Error fetching coin list:', err);
      setCoins([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCoins();
  }, [fetchCoins]);

  return {
    coins,
    loading,
    error,
    refetch: fetchCoins,
  };
};


